import { DocumentStatus } from "../types/document.types"

export const statusOptions = [
  { key: DocumentStatus.VALIDATED, text: "Vérifié", value: DocumentStatus.VALIDATED },
  { key: DocumentStatus.NEW, text: "Nouveau", value: DocumentStatus.NEW },
  { key: DocumentStatus.PENDING, text: "À renvoyer", value: DocumentStatus.PENDING },
  { key: DocumentStatus.REJECTED, text: "Rejeté", value: DocumentStatus.REJECTED },
]
